import React, {useState} from "react";
import { Formik, Form } from "formik";
import InputField from "../../../shared/components/InputField";
import { validationSchema } from "./ForgotPasswordValidation";
import UserService from "../../../services/AuthService/auth.service";
import { withRouter } from "react-router-dom";
import '../auth.scss';
import ButtonComponent from "../../../shared/components/ButtonComponent";
import backArrow from "../../../assets/icons/back_arrow.svg";
import * as appRoutes from "../../../routes/routeConstants/appRoutes";

interface User {
    email: string,
}

const initialValue = {
    email: "",
}

const ForgotPassword = (props: any) => {

    const [buttonLoading, setButtonLoading] = useState<boolean>(false)

    const onSubmit = (user: User) => {
        setButtonLoading(true)

        setButtonLoading(true);

        let data:any = {};

        data['admin'] = {
            ...user,
            // redirect_url: 'http://panditji-admin-app.s3-website.us-east-2.amazonaws.com/reset-password'
            redirect_url: window.location.origin+'/auth/reset-password'
        }

        UserService.forgotPassword(data,
            (user: any) => {
                //return props.history.push(appRoutes.RESET_PASSWORD);
            }, (error: Error) => {
                console.log(error.message);
            }, () => {
                setButtonLoading(false)
            }).then();
    }

    return (
        <div className='auth__form'>
            <div className='auth__header'>
                <img src={backArrow} alt='' className='auth__back'
                     onClick={()=>props.history.push(appRoutes.LOGIN)}
                /> Forgot Password
            </div>
            <Formik
                initialValues={initialValue}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
            >
                <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <div className="auth__input">
                        <InputField type="email" name="email" placeholder="Email ID" />
                    </div>
                    <div className='auth__action forgot-password__action'>
                        <ButtonComponent buttonContent='Send mail'
                                         type='primary'
                                         htmlType='submit'
                                         loading={buttonLoading}
                        />
                    </div>
                </Form>
            </Formik>
        </div>
    )
}

export default withRouter(ForgotPassword);
